import { IAddAGuarantorFieldProps } from '../AddAGuarantor.types';

type AddATenantFieldKey = keyof IAddAGuarantorFieldProps;

const RequiredFieldForGurantor: { label: string; value: AddATenantFieldKey }[] =
  [
    { label: 'form:firstName', value: 'firstName' },
    { label: 'form:lastName', value: 'lastName' },
    { label: 'form:email', value: 'email' },
    { label: 'form:placeOfBirth', value: 'placeOfBirth' },
    { label: 'form:dateOfBirth', value: 'dateOfBirth' },
    { label: 'form:monthlyIncome', value: 'monthlyIncome' },
    { label: 'form:occupation', value: 'occupation' },
  ];

export const filterRequiredFieldForGurantor = ({
  index,
  guarantor,
}: {
  index: number;
  guarantor: IAddAGuarantorFieldProps;
}) => {
  const emptyFields = RequiredFieldForGurantor.filter(
    field => !guarantor[field.value],
  ).map(field => field.label);

  const label =
    index === 0 ? 'documentsflow:guarantor' : 'documentsflow:otherGuarantor';

  return {
    label,
    fields: emptyFields,
  };
};
